// What a view lists of the viewer's comments while one of them is being
// saved from a box that is still open: that one is on screen in its box
// (`Writes.tell`), and takes its place in the list once the box closes or
// the server has it. Counts elsewhere (the file list's, the Review tab's)
// read every pending draft and so include it from the press.
import type { ReviewThread } from '../api/queries';
import type { ReviewDraft } from '../api/server';
import { subject, type Subject } from './optimistic';

/** The part of the pending writes this reads. */
export interface InBox {
  shownInBox(subject: Subject): boolean;
}

/** The review threads of `path` to show in its code: all of them but a new one still shown in its open composer. */
export function threadsToShow(threads: readonly ReviewThread[], path: string | null, writes: InBox): ReviewThread[] {
  return threads.filter((t) => t.path === path && !writes.shownInBox(subject.thread(t.id)));
}

/** Whether a held draft is shown in the code: not while it is new and still shown in its open composer. */
export function heldToShow(draft: Pick<ReviewDraft, 'id'>, writes: InBox): boolean {
  return !writes.shownInBox(subject.draft(draft.id));
}
